var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import './types';
var AcceptLarge = function (props) { return (React.createElement("svg", __assign({}, props),
    React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M19.6464 6.35355C19.8417 6.15829 20.1583 6.15829 20.3536 6.35355L20.7071 6.70711C20.9024 6.90237 20.9024 7.21895 20.7071 7.41421L9.88388 18.2374C9.68862 18.4327 9.37204 18.4327 9.17678 18.2374L4.35355 13.4142C4.15829 13.219 4.15829 12.9024 4.35355 12.7071L4.70711 12.3536C4.90237 12.1583 5.21895 12.1583 5.41421 12.3536L9.53033 16.4697L19.6464 6.35355Z", fill: "currentColor" }))); };
AcceptLarge.defaultProps = {
    width: '24',
    height: '24',
    viewBox: '0 0 24 24',
    fill: 'none',
    xmlns: 'http://www.w3.org/2000/svg',
};
var AcceptSmall = function (props) { return (React.createElement("svg", __assign({}, props),
    React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", fill: "currentColor", d: "m13.780311,3.719681c0.2929,0.29289 0.2929,0.76777 0,1.06066l-7.49997,7.49997c-0.29289,0.2929 -0.76777,0.2929 -1.06066,0l-3,-2.99997c-0.29289,-0.29289 -0.29289,-0.76777 0,-1.06066c0.29289,-0.29289 0.76777,-0.29289 1.06066,0l1.76256,1.76256c0.39053,0.39057 1.02369,0.39057 1.41422,0l6.26259,-6.26256c0.2929,-0.29289 0.7677,-0.29289 1.0606,0z" }))); };
AcceptSmall.defaultProps = {
    width: '16',
    height: '16',
    viewBox: '0 0 16 16',
    fill: 'none',
    xmlns: 'http://www.w3.org/2000/svg',
};
var sizeMap = {
    large: AcceptLarge,
    small: AcceptSmall,
};
export var Accept = function (props) {
    var _a = props.size, size = _a === void 0 ? 'large' : _a, other = __rest(props, ["size"]);
    var Icon = sizeMap[size];
    return React.createElement(Icon, __assign({}, other));
};
export default Accept;
//# sourceMappingURL=Accept.js.map